module.exports = __webpack_public_path__ + "media/images/front/brands/creations/creations_1-d7812488a232255ac820a8214cbc88c5.webp";